exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InputWithUnit {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.InputWithUnit > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\theight: 26px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.InputWithUnit input {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\ttext-align: right;\r\n\tmargin: 0px;\r\n}\r\n\r\n.InputWithUnit label {\r\n\tpadding: 5px;\r\n\theight: 26px;\r\n\t\r\n\tcolor: #AAA;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.InputWithUnit.Shadowed {\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.InputWithUnit.Shadowed .Input {\r\n\tborder-bottom: 0;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/InputWithUnit/InputWithUnit.css
// module id = 689
// module chunks = 0